import BackgroundCategoryTranslationsRequest from './BackgroundCategoryTranslationsRequest';

export default class BackgroundCategoryAddRequest {
	Id?: number = null;
	Translations: Array<BackgroundCategoryTranslationsRequest> = null;
	constructor(obj?: Partial<BackgroundCategoryAddRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
